export default __webpack_public_path__ + "static/media/orion-logo-light.b62b6aec.png";